import React, { useState } from "react"

import { Grid, Button } from "@material-ui/core"
import { styles } from "./styles"
import useCustomSnackbar from "Components/UI/Atoms/SnackBar"
import PictureCardWithZoom from "Components/UI/Atoms/PictureCard/PictureCardWithZoom"

import { interfaces } from "service/interfaces"
import DialogUpload from "Components/UI/Molecules/Vehicles/SearchVehicles/DialogVehicle/Content/Tabs/Content/Files/Tabs/AdditionalPhotos/DialogUpload"
import DeletePhoto from "Components/UI/Molecules/Vehicles/SearchVehicles/DialogVehicle/Content/Tabs/Content/Files/Tabs/AdditionalPhotos/DialogDelete"

const AdditionalPhotos = ({ edit, data, id }) => {
  const [change, setChange] = useState([])
  const [dataActions, setDataActions] = useState({})
  const [loading, setLoading] = useState(false)

  const createDismissableSnackbar = useCustomSnackbar()
  const classes = styles()

  function handleOpenDelete(data, index, openRemove) {
    setDataActions({
      data: data,
      index: index,
      openRemove: openRemove,
      id: id,
    })
  }
  function handleOpenUpload() {
    setDataActions({
      openUpload: true,
      id: id,
    })
  }

  function handleChange(e) {
    e.preventDefault()
    let prevData = [...change]
    let files = e.target.files
    for (let i = 0; i < files.length; i++) {
      prevData[i] = files[i]
    }
    setChange(prevData)
  }
  function handleCloseActions() {
    setChange([])
    setDataActions({
      openUpload: false,
      openRemove: false,
      id: null,
    })
  }

  function handleDeleteContext(index) {
    let delet = index - 1
    data.fotos.splice(delet, 1)
  }

  function handleAdd(arr) {
    for (let i = 0; i < arr.length; i++) {
      let imgUp = URL.createObjectURL(arr[i])
      data.fotos.push(imgUp)
    }
  }

  async function handleSubmitUpload(value) {
    setLoading(true)
    await interfaces.quotationsInterface
      .uploadPhoto(id, data.dominio, value)
      .then((res) => {
        createDismissableSnackbar(`${res.data.msg}`, {
          variant: "success",
        })
        handleAdd(value)
        handleCloseActions()
      })
      .catch(() => {
        createDismissableSnackbar("Error", {
          variant: "error",
        })
        handleCloseActions()
      })
    setLoading(false)
  }
  async function handleSubmitDelete(arr, index) {
    setLoading(true)
    if (arr !== "" && arr !== undefined) {
      await interfaces.quotationsInterface
        .deletePhoto(id, index)
        .then((res) => {
          createDismissableSnackbar(res.data, {
            variant: "success",
          })
          handleDeleteContext(index)
          handleCloseActions()
        })
        .catch((error) => {
          createDismissableSnackbar(error.response.data.data, {
            variant: "error",
          })
          handleCloseActions()
        })
    } else {
      createDismissableSnackbar("Esta foto no existe! ", {
        variant: "error",
      })
      handleCloseActions()
    }
    setLoading(false)
  }

  const swipes = data.fotos.map((item, index) => ({
    id: index,
    img: item,
  }))

  return (
    <div className={classes.root}>
      <Grid container alignContent="center" justify="center" spacing={2}>
        {data.fotos.map((item, index) => (
          <Grid item xs={12} xl={4} sm={6} md={4} className={classes.root2}>
            <PictureCardWithZoom
              img={item}
              edit={edit}
              txt={`Adicional ${index + 1}`}
              title={`Adicional ${index + 1}`}
              index={index + 1}
              swipes={swipes}
              handleDelete={() => handleOpenDelete(item, index + 1, true)}
            />
          </Grid>
        ))}
        {edit ? (
          <Grid item xs={12} xl={6} sm={6} md={6}>
            <Button 
             onClick={() => handleOpenUpload()} 
             color="primary"
             variant="contained"
             className={classes.button}
            >
              Subir imagen
            </Button>
          </Grid>
        ) : null}
      </Grid>
      <DeletePhoto
        data={dataActions}
        open={dataActions.openRemove}
        handleClose={handleCloseActions}
        onSubmit={handleSubmitDelete}
        loading={loading}
      />
      <DialogUpload
        handleChange={handleChange}
        change={change}
        data={dataActions}
        onSubmit={handleSubmitUpload}
        handleClose={handleCloseActions}
        open={dataActions.openUpload}
        loading={loading}
      />
    </div>
  )
}

export default AdditionalPhotos
